
import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Notification } from '../Notification/Notification';
import CircularProgress from '@mui/material/CircularProgress';
import '../Index.css';

function Feed(props) {

    const [notifications, setNotifications] = React.useState([]);
    const [notificationsLoaded, setNotificationsLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        if (props.logged) {
            fetch(`${props.url}/procesos-api/get-notifications`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token '+ localStorage.getItem('token'),
                },
                body: JSON.stringify({
                    token: localStorage.getItem('token')
                })
            })
            .then(res => res.json())
            .then(json => {
                    setNotifications(json.notifications);
                    setNotificationsLoaded(true);
            })
            .catch((e) => {
                setNotificationsLoaded(true);
                setError(true);
            })
        }
        
    }, [props.url, props.logged])

    const date = new Date();

    return(
        <React.Fragment>
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="index-container">
                    <div className="titleMisProcesos">Hola, {props.username} </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="date">{date.toLocaleString('es-CO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="grid-row">
                        <div className="subgrid">Notificaciones:</div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="grid-row">
                        <div className="subgrid">
                            <Box>
                            <div>
                                    {!notificationsLoaded ?   <CircularProgress /> :
                                     error ?    <div>
                                                    <div className='empty-emoji'><span>&#128561;</span></div>
                                                    <div className='text-misProcesos'>Hubo un error</div>
                                                </div> :
                                     notifications.length > 0 ? notifications.map((element) => {
                                        return(
                                                <div key={`${notifications.indexOf(element)}_`} className="notification-home">
                                                    <Notification  content={JSON.stringify(element)} 
                                                           setOpenCaseInfo={props.setOpenCaseInfo}
                                                           url={props.url}
                                                    />
                                                </div>
                                            )
                                        }) :
                                        <div>
                                            <div className='empty-emoji'><span>&#128564;</span></div>
                                            <div className='text-misProcesos'>No tienes notificaciones</div>
                                        </div>
                                    } 
                                </div>
                            </Box>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export { Feed }